import * as actionTypes from './actionTypes';
import gtagEvent from '../../services/gtagEvent';

export const createUser = (fullName, email, password) => {
  // gtagEvent(actionTypes.CREATE_USER);
  return {
    type: actionTypes.CREATE_USER,
    fullName,
    email,
    password,
  };
};

export const createUserStart = () => {
  // gtagEvent(actionTypes.CREATE_USER_START);
  return { type: actionTypes.CREATE_USER_START };
};

export const createUserSuccess = () => {
  gtagEvent(actionTypes.CREATE_USER_SUCCESS);
  return { type: actionTypes.CREATE_USER_SUCCESS };
};

export const createUserFail = (error) => {
  gtagEvent(actionTypes.CREATE_USER_FAIL);
  return { type: actionTypes.CREATE_USER_FAIL, error };
};

export const signInWithEmail = (email, password) => {
  // gtagEvent(actionTypes.SIGN_IN_WITH_EMAIL);
  return {
    type: actionTypes.SIGN_IN_WITH_EMAIL,
    email,
    password,
  };
};

export const signInWithEmailStart = () => {
  // gtagEvent(actionTypes.SIGN_IN_WITH_EMAIL_START);
  return { type: actionTypes.SIGN_IN_WITH_EMAIL_START };
};

export const signInWithEmailSuccess = (authUser) => {
  gtagEvent(actionTypes.SIGN_IN_WITH_EMAIL_SUCCESS);
  return { type: actionTypes.SIGN_IN_WITH_EMAIL_SUCCESS, payload: { authUser } };
};

export const signInWithEmailFail = (error) => {
  gtagEvent(actionTypes.SIGN_IN_WITH_EMAIL_FAIL);
  return { type: actionTypes.SIGN_IN_WITH_EMAIL_FAIL, error };
};

export const signInWithToken = (token) => {
  // gtagEvent(actionTypes.SIGN_IN_WITH_TOKEN);
  return { type: actionTypes.SIGN_IN_WITH_TOKEN, payload: { token } };
};

export const signInWithTokenStart = () => {
  // gtagEvent(actionTypes.SIGN_IN_WITH_TOKEN_START);
  return { type: actionTypes.SIGN_IN_WITH_TOKEN_START };
};

export const signInWithTokenSuccess = (authUser) => {
  gtagEvent(actionTypes.SIGN_IN_WITH_TOKEN_SUCCESS);
  return { type: actionTypes.SIGN_IN_WITH_TOKEN_SUCCESS, payload: { authUser } };
};

export const signInWithTokenFail = (error) => {
  gtagEvent(actionTypes.SIGN_IN_WITH_TOKEN_FAIL);
  return { type: actionTypes.SIGN_IN_WITH_TOKEN_FAIL, payload: { error } };
};

export const signInWithGoogle = () => {
  // gtagEvent(actionTypes.SIGN_IN_WITH_GOOGLE);
  return { type: actionTypes.SIGN_IN_WITH_GOOGLE };
};

export const signInWithGoogleStart = () => {
  // gtagEvent(actionTypes.SIGN_IN_WITH_GOOGLE_START);
  return { type: actionTypes.SIGN_IN_WITH_GOOGLE_START };
};

export const signInWithGoogleSuccess = () => {
  gtagEvent(actionTypes.SIGN_IN_WITH_GOOGLE_SUCCESS);
  return { type: actionTypes.SIGN_IN_WITH_GOOGLE_SUCCESS };
};

export const signInWithGoogleFail = (error) => {
  gtagEvent(actionTypes.SIGN_IN_WITH_GOOGLE_FAIL);
  return { type: actionTypes.SIGN_IN_WITH_GOOGLE_FAIL, error };
};

export const signInWithFacebook = () => {
  // gtagEvent(actionTypes.SIGN_IN_WITH_FACEBOOK);
  return { type: actionTypes.SIGN_IN_WITH_FACEBOOK };
};

export const signInWithFacebookStart = () => {
  // gtagEvent(actionTypes.SIGN_IN_WITH_FACEBOOK_START);
  return { type: actionTypes.SIGN_IN_WITH_FACEBOOK_START };
};

export const signInWithFacebookSuccess = () => {
  gtagEvent(actionTypes.SIGN_IN_WITH_FACEBOOK_SUCCESS);
  return { type: actionTypes.SIGN_IN_WITH_FACEBOOK_SUCCESS };
};

export const signInWithFacebookFail = (error) => {
  gtagEvent(actionTypes.SIGN_IN_WITH_FACEBOOK_FAIL);
  return { type: actionTypes.SIGN_IN_WITH_FACEBOOK_FAIL, error };
};

export const passwordReset = (email) => {
  // gtagEvent(actionTypes.PASSWORD_RESET);
  return {
    type: actionTypes.PASSWORD_RESET,
    email,
  };
};

export const passwordResetStart = () => {
  // gtagEvent(actionTypes.PASSWORD_RESET_START);
  return { type: actionTypes.PASSWORD_RESET_START };
};

export const passwordResetSuccess = () => {
  gtagEvent(actionTypes.PASSWORD_RESET_SUCCESS);
  return { type: actionTypes.PASSWORD_RESET_SUCCESS };
};

export const passwordResetFail = (error) => {
  gtagEvent(actionTypes.PASSWORD_RESET_FAIL);
  return { type: actionTypes.PASSWORD_RESET_FAIL, error };
};

export const updatePassword = (passwordOld, password) => {
  // gtagEvent(actionTypes.UPDATE_PASSWORD);
  return { type: actionTypes.UPDATE_PASSWORD, payload: { passwordOld, password } };
};

export const updatePasswordStart = () => {
  // gtagEvent(actionTypes.UPDATE_PASSWORD_START);
  return { type: actionTypes.UPDATE_PASSWORD_START };
};

export const updatePasswordSuccess = () => {
  gtagEvent(actionTypes.UPDATE_PASSWORD_SUCCESS);
  return { type: actionTypes.UPDATE_PASSWORD_SUCCESS };
};

export const updatePasswordFail = (error) => {
  gtagEvent(actionTypes.UPDATE_PASSWORD_FAIL);
  return { type: actionTypes.UPDATE_PASSWORD_FAIL, error };
};

export const setPassword = (passwordOne, passwordTwo, token) => {
  // gtagEvent(actionTypes.SET_PASSWORD);
  return {
    type: actionTypes.SET_PASSWORD,
    payload: {
      passwordOne,
      passwordTwo,
      token,
    },
  };
};

export const setPasswordStart = () => {
  // gtagEvent(actionTypes.SET_PASSWORD_START);
  return { type: actionTypes.SET_PASSWORD_START };
};

export const setPasswordSuccess = () => {
  gtagEvent(actionTypes.SET_PASSWORD_SUCCESS);
  return { type: actionTypes.SET_PASSWORD_SUCCESS };
};

export const setPasswordFail = (error) => {
  gtagEvent(actionTypes.SET_PASSWORD_FAIL);
  return { type: actionTypes.SET_PASSWORD_FAIL, error };
};

export const authStateChanged = () => {
  // gtagEvent(actionTypes.AUTH_STATE_CHANGED);
  return { type: actionTypes.AUTH_STATE_CHANGED };
};

export const authStateChangedStart = () => {
  // gtagEvent(actionTypes.AUTH_STATE_CHANGED_START);
  return { type: actionTypes.AUTH_STATE_CHANGED_START };
};

export const authStateChangedSuccess = (authUser) => {
  // gtagEvent(actionTypes.AUTH_STATE_CHANGED_SUCCESS);
  return { type: actionTypes.AUTH_STATE_CHANGED_SUCCESS, payload: { authUser } };
};

export const authStateChangedFail = (error) => {
  // gtagEvent(actionTypes.AUTH_STATE_CHANGED_FAIL);
  return { type: actionTypes.AUTH_STATE_CHANGED_FAIL, error };
};

export const logout = () => {
  // gtagEvent(actionTypes.LOGOUT);
  return { type: actionTypes.LOGOUT };
};

export const logoutStart = () => {
  // gtagEvent(actionTypes.LOGOUT_START);
  return { type: actionTypes.LOGOUT_START };
};

export const logoutSuccess = () => {
  gtagEvent(actionTypes.LOGOUT_SUCCESS);
  return { type: actionTypes.LOGOUT_SUCCESS };
};

export const logoutFail = (error) => {
  gtagEvent(actionTypes.LOGOUT_FAIL);
  return { type: actionTypes.LOGOUT_FAIL, error };
};

export const setNames = (names = {}) => {
  // gtagEvent(actionTypes.SET_NAMES);
  return { type: actionTypes.SET_NAMES, payload: { names } };
};

export const setNamesStart = () => {
  // gtagEvent(actionTypes.SET_NAMES_START);
  return { type: actionTypes.SET_NAMES_START };
};

export const setNamesSuccess = (names = {}) => {
  gtagEvent(actionTypes.SET_NAMES_SUCCESS);
  return { type: actionTypes.SET_NAMES_SUCCESS, payload: { names } };
};

export const setNamesFail = (error) => {
  gtagEvent(actionTypes.SET_NAMES_FAIL);
  return { type: actionTypes.SET_NAMES_FAIL, payload: { error } };
};

export const setLanguage = (language) => {
  // gtagEvent(actionTypes.SET_LANGUAGE);
  return { type: actionTypes.SET_LANGUAGE, payload: { language } };
};

export const setLanguageStart = () => {
  // gtagEvent(actionTypes.SET_LANGUAGE_START);
  return { type: actionTypes.SET_LANGUAGE_START };
};

export const setLanguageSuccess = () => {
  gtagEvent(actionTypes.SET_LANGUAGE_SUCCESS);
  return { type: actionTypes.SET_LANGUAGE_SUCCESS };
};

export const setLanguageFail = (error) => {
  gtagEvent(actionTypes.SET_LANGUAGE_FAIL);
  return { type: actionTypes.SET_LANGUAGE_FAIL, payload: { error } };
};

export const setDarkMode = () => {
  // gtagEvent(actionTypes.SET_DARK_MODE);
  return { type: actionTypes.SET_DARK_MODE };
};

export const setDarkModeStart = () => {
  // gtagEvent(actionTypes.SET_DARK_MODE_START);
  return { type: actionTypes.SET_DARK_MODE_START };
};

export const setDarkModeSuccess = () => {
  gtagEvent(actionTypes.SET_DARK_MODE_SUCCESS);
  return { type: actionTypes.SET_DARK_MODE_SUCCESS };
};

export const setDarkModeFail = (error) => {
  gtagEvent(actionTypes.SET_DARK_MODE_FAIL);
  return { type: actionTypes.SET_DARK_MODE_FAIL, payload: { error } };
};

export const setDisableTasksDone = (disableTasksDone) => {
  // gtagEvent(actionTypes.SET_DISABLE_TASKS_DONE);
  return { type: actionTypes.SET_DISABLE_TASKS_DONE, payload: { disableTasksDone } };
};

export const setDisableTasksDoneStart = () => {
  // gtagEvent(actionTypes.SET_DISABLE_TASKS_DONE_START);
  return { type: actionTypes.SET_DISABLE_TASKS_DONE_START };
};

export const setDisableTasksDoneSuccess = (disableTasksDone) => {
  gtagEvent(actionTypes.SET_DISABLE_TASKS_DONE_SUCCESS);
  return { type: actionTypes.SET_DISABLE_TASKS_DONE_SUCCESS, payload: { disableTasksDone } };
};

export const setDisableTasksDoneFail = (error) => {
  gtagEvent(actionTypes.SET_DISABLE_TASKS_DONE_FAIL);
  return { type: actionTypes.SET_DISABLE_TASKS_DONE_FAIL, payload: { error } };
};

export const setDisableAdviceShow = (disableAdviceShow) => {
  // gtagEvent(actionTypes.SET_DISABLE_ADVICE_SHOW);
  return { type: actionTypes.SET_DISABLE_ADVICE_SHOW, payload: { disableAdviceShow } };
};

export const setDisableAdviceShowStart = () => {
  // gtagEvent(actionTypes.SET_DISABLE_ADVICE_SHOW_START);
  return { type: actionTypes.SET_DISABLE_ADVICE_SHOW_START };
};

export const setDisableAdviceShowSuccess = (disableAdviceShow) => {
  gtagEvent(actionTypes.SET_DISABLE_ADVICE_SHOW_SUCCESS);
  return { type: actionTypes.SET_DISABLE_ADVICE_SHOW_SUCCESS, payload: { disableAdviceShow } };
};

export const setDisableAdviceShowFail = (error) => {
  gtagEvent(actionTypes.SET_DISABLE_ADVICE_SHOW_FAIL);
  return { type: actionTypes.SET_DISABLE_ADVICE_SHOW_FAIL, payload: { error } };
};

export const setAdviceShowedAt = (adviceShowedAt) => {
  // gtagEvent(actionTypes.SET_ADVICE_SHOWED_AT);
  return { type: actionTypes.SET_ADVICE_SHOWED_AT, payload: { adviceShowedAt } };
};

export const setAdviceShowedAtStart = () => {
  // gtagEvent(actionTypes.SET_ADVICE_SHOWED_AT_START);
  return { type: actionTypes.SET_ADVICE_SHOWED_AT_START };
};

export const setAdviceShowedAtSuccess = (adviceShowedAt) => {
  gtagEvent(actionTypes.SET_ADVICE_SHOWED_AT_SUCCESS);
  return { type: actionTypes.SET_ADVICE_SHOWED_AT_SUCCESS, payload: { adviceShowedAt } };
};

export const setAdviceShowedAtFail = (error) => {
  gtagEvent(actionTypes.SET_ADVICE_SHOWED_AT_FAIL);
  return { type: actionTypes.SET_ADVICE_SHOWED_AT_FAIL, payload: { error } };
};

export const setShowGlobalTasksAsList = (showGlobalTasksAsList) => {
  // gtagEvent(actionTypes.SET_SHOW_GLOBAL_TASKS_AS_LIST);
  return { type: actionTypes.SET_SHOW_GLOBAL_TASKS_AS_LIST, payload: { showGlobalTasksAsList } };
};

export const setShowGlobalTasksAsListStart = () => {
  // gtagEvent(actionTypes.SET_SHOW_GLOBAL_TASKS_AS_LIST_START);
  return { type: actionTypes.SET_SHOW_GLOBAL_TASKS_AS_LIST_START };
};

export const setShowGlobalTasksAsListSuccess = (showGlobalTasksAsList) => {
  gtagEvent(actionTypes.SET_SHOW_GLOBAL_TASKS_AS_LIST_SUCCESS);
  return { type: actionTypes.SET_SHOW_GLOBAL_TASKS_AS_LIST_SUCCESS, payload: { showGlobalTasksAsList } };
};

export const setShowGlobalTasksAsListFail = (error) => {
  gtagEvent(actionTypes.SET_SHOW_GLOBAL_TASKS_AS_LIST_FAIL);
  return { type: actionTypes.SET_SHOW_GLOBAL_TASKS_AS_LIST_FAIL, payload: { error } };
};

export const registerDeviceToken = (platform, deviceId, token) => {
  // gtagEvent(actionTypes.REGISTER_DEVICE_TOKEN);
  return {
    type: actionTypes.REGISTER_DEVICE_TOKEN,
    payload: {
      platform,
      deviceId,
      token,
    },
  };
};

export const registerDeviceTokenStart = () => {
  // gtagEvent(actionTypes.REGISTER_DEVICE_TOKEN_START);
  return { type: actionTypes.REGISTER_DEVICE_TOKEN_START };
};

export const registerDeviceTokenSuccess = () => {
  gtagEvent(actionTypes.REGISTER_DEVICE_TOKEN_SUCCESS);
  return { type: actionTypes.REGISTER_DEVICE_TOKEN_SUCCESS };
};

export const registerDeviceTokenFail = (error) => {
  gtagEvent(actionTypes.REGISTER_DEVICE_TOKEN_FAIL);
  return { type: actionTypes.REGISTER_DEVICE_TOKEN_FAIL, payload: { error } };
};
